module.exports = __webpack_public_path__ + "static/media/check_box_active.4447a2c1.svg";